import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class ProdWarehouseService extends DatabaseGwService{

  URL_PATH: string = "/prod-warehouse-details";
}
